import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeftRight, TriangleAlert, Wrench } from 'lucide-react';
import StatCard from './StatCard';

interface ResultsSummaryCardsProps {
  designChangesCount: number;
  failureModesCount: number;
  countermeasuresCount: number;
  criticalCount: number;
  highPriorityCount: number;
}

const ResultsSummaryCards: React.FC<ResultsSummaryCardsProps> = ({
  designChangesCount,
  failureModesCount,
  countermeasuresCount,
  criticalCount,
  highPriorityCount,
}) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
      <StatCard
        testId="drbfm-stat-card-design-changes"
        icon={<ArrowLeftRight className="h-10 w-10 text-primary mb-2 mx-auto" />}
        count={designChangesCount}
        countClassName="text-primary"
        label={t('drbfm.stats.designChanges')}
      />
      <StatCard
        testId="drbfm-stat-card-failure-modes"
        icon={<TriangleAlert className="h-10 w-10 text-warning mb-2 mx-auto" />}
        count={failureModesCount}
        countClassName="text-warning"
        label={t('drbfm.stats.failureModes')}
        badge={
          criticalCount > 0
            ? { text: t('drbfm.stats.critical', { count: criticalCount }), variant: 'destructive' }
            : undefined
        }
      />
      <StatCard
        testId="drbfm-stat-card-countermeasures"
        icon={<Wrench className="h-10 w-10 text-success mb-2 mx-auto" />}
        count={countermeasuresCount}
        countClassName="text-success"
        label={t('drbfm.stats.countermeasures')}
        badge={
          highPriorityCount > 0
            ? { text: t('drbfm.stats.highPriority', { count: highPriorityCount }) }
            : undefined
        }
      />
    </div>
  );
};

export default ResultsSummaryCards;
